class SectionDots {
  constructor(lenis) {
    this.lenis = lenis
    this.events()
  }

  events() {
    const sectionDotsContainer = document.getElementById('js-section-dots')
    const contentSections = document.querySelectorAll('.js-content-section')
    
    if (!sectionDotsContainer || contentSections.length === 0) return

    // Clear existing dots
    sectionDotsContainer.innerHTML = ''

    // Create dots for each section
    const dots = []
    const sections = Array.from(contentSections)
    
    sections.forEach((section, index) => {
      const dot = document.createElement('span')
      dot.className = 'section-dots__dot'
      if (index === 0) {
        dot.classList.add('is-active')
      }
      
      const dotInner = document.createElement('span')
      dotInner.className = 'section-dots__dot-inner'
      dot.appendChild(dotInner)
      
      sectionDotsContainer.appendChild(dot)
      dots.push({ dot, dotInner, section })
    })

    // Track active section and scroll progress
    let activeIndex = 0

    // Calculate scroll progress for a section (0 to 1)
    // Progress starts at 0 when section enters viewport (section top reaches viewport bottom)
    // Progress reaches 1 when next section enters viewport (next section top reaches viewport bottom)
    const getScrollProgress = (sectionIndex) => {
      const section = sections[sectionIndex]
      if (!section) return 0

      const rect = section.getBoundingClientRect()
      const windowHeight = window.innerHeight
      const sectionTop = rect.top
      
      // Entry: sectionTop = windowHeight (section top at viewport bottom)
      // Exit: nextSectionTop = windowHeight (next section top at viewport bottom)
      
      // If section hasn't entered viewport yet
      if (sectionTop > windowHeight) {
        return 0
      }
      
      // Check next section
      const nextSection = sections[sectionIndex + 1]
      if (nextSection) {
        const nextRect = nextSection.getBoundingClientRect()
        const nextSectionTop = nextRect.top
        
        // If next section has entered, we're at 100%
        if (nextSectionTop <= windowHeight) {
          return 1
        }
        
        // Calculate progress based on scroll distance
        // The distance between section top and next section top is constant
        // At entry: sectionTop = windowHeight
        // At exit: nextSectionTop = windowHeight (which means sectionTop = windowHeight - sectionSpacing)
        // Progress = how far sectionTop has moved from windowHeight
        const sectionSpacing = nextSectionTop - sectionTop
        if (sectionSpacing <= 0) return 1
        
        // How far has sectionTop moved from entry point (windowHeight)?
        const scrollDistance = windowHeight - sectionTop
        // Total distance to scroll = sectionSpacing (distance between sections)
        const progress = scrollDistance / sectionSpacing
        
        return Math.max(0, Math.min(1, progress))
      } else {
        // Last section - fill as section scrolls through viewport
        // Progress reaches 100% when section bottom reaches viewport bottom
        const sectionBottom = rect.bottom
        const sectionHeight = rect.height
        
        // Progress: 0 when top enters (sectionTop = windowHeight), 1 when bottom reaches viewport bottom (sectionBottom = windowHeight)
        // At entry: sectionTop = windowHeight, sectionBottom = windowHeight + sectionHeight
        // At exit: sectionBottom = windowHeight, sectionTop = windowHeight - sectionHeight
        // Total scroll distance = sectionHeight
        // Current scroll distance = windowHeight - sectionTop
        if (sectionBottom <= windowHeight) {
          return 1 // Section bottom has reached or passed viewport bottom
        }
        
        const scrollDistance = windowHeight - sectionTop
        const progress = scrollDistance / sectionHeight
        
        return Math.max(0, Math.min(1, progress))
      }
    }

    // Update dot fill based on scroll progress
    const updateDotProgress = (index, progress) => {
      if (dots[index]) {
        const { dotInner } = dots[index]
        // Set width as percentage (0% to 100%)
        dotInner.style.width = `${progress * 100}%`
      }
    }

    // Update active dot
    const updateActiveDot = (index) => {
      dots.forEach(({ dot }, i) => {
        if (i === index) {
          dot.classList.add('is-active')
        } else {
          dot.classList.remove('is-active')
          // Reset progress for inactive dots
          dots[i].dotInner.style.width = '0%'
        }
      })
      activeIndex = index
    }

    // Intersection Observer to detect which section is visible
    // Trigger when section top reaches the bottom of the viewport
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px 0px 0px', // Use full viewport
      threshold: [0, 0.01, 0.02, 0.05, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0] // Multiple thresholds for precise detection
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const sectionIndex = sections.indexOf(entry.target)
        if (sectionIndex === -1) return

        if (entry.isIntersecting) {
          // Get current position of section top relative to viewport
          const rect = entry.boundingClientRect
          const windowHeight = window.innerHeight
          
          // Trigger when section top reaches or passes the bottom of viewport
          // This means the top of the section is visible at the bottom edge
          if (rect.top <= windowHeight) {
            updateActiveDot(sectionIndex)
          }
        }
      })
    }, observerOptions)

    // Observe all sections
    sections.forEach((section) => {
      observer.observe(section)
    })

    // Update scroll progress on scroll
    const updateScrollProgress = () => {
      const windowHeight = window.innerHeight
      let newActiveIndex = activeIndex

      // Find which section's top has reached or passed the bottom of viewport
      // The active section is the one whose top is closest to (but above or at) the bottom of viewport
      for (let i = sections.length - 1; i >= 0; i--) {
        const rect = sections[i].getBoundingClientRect()
        const sectionTop = rect.top
        
        // If section top has reached or passed the bottom of viewport, this is the active section
        if (sectionTop <= windowHeight) {
          newActiveIndex = i
          break
        }
      }

      // Update active dot if changed
      if (newActiveIndex !== activeIndex) {
        updateActiveDot(newActiveIndex)
      }

      // Update progress for active section
      if (dots[activeIndex]) {
        const progress = getScrollProgress(activeIndex)
        updateDotProgress(activeIndex, progress)
      }
    }

    // Use Lenis scroll event if available, otherwise use window scroll
    if (this.lenis) {
      this.lenis.on('scroll', () => {
        updateScrollProgress()
      })
    } else {
      window.addEventListener('scroll', updateScrollProgress, { passive: true })
    }

    // Initial update
    updateScrollProgress()
  }
}

export default SectionDots